import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=specialTown&instance=${instance}`
    }

    return [{
         
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '华美顾问集团',
        description_backdrop: true,
        pageTitleIcon: '',
        huameiImage: 'https://hm-cloud-v3.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87%E7%B4%A0%E6%9D%90/%E5%8D%8E%E7%BE%8E%E5%9B%BE%E7%89%87/Map.png',
        description: `华美顾问集团是中国领先的酒店咨询顾问公司。华美顾问于2001年在中国深圳创立，主要致力于为酒店、酒店集团、酒店地产、旅游度假目的地、特色小镇、幸福产业等提供全面的咨询顾问服务，目前在深圳、北京、上海、成都设有四个办公室，已在中国400+城市为1800+项目提供服务。`,

        icons:[
            {
                name: '华美简介',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/华美简介'),
                background: 'black',
                path: "华美顾问/华美简介" ,
            },
            {
                name: '华美服务',
                img: '/icons/案例库.svg',
                url: makeUrl('华美服务'),
                background: 'black',
                path: "华美顾问/华美服务" ,
            },
            {
                name: '华美项目',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/华美项目'),
                background: 'black',
                path: "华美顾问/华美项目",
            },
            {
                name: '项目报告',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/项目报告'),
                background: 'black',
                path: "华美顾问/项目报告",
            },
            {
                name: '华美研究',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/华美研究'),
                background: 'black',
                path: "华美顾问/华美研究",
            },
            {
                name: '市场机会',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/市场机会'),
                background: 'black',
                path: "华美顾问/市场机会",
            },
            {
                name: '客户管理',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/华美/客户管理'),
                background: 'black',
                path: "华美顾问/客户管理",
            },
            {
                name: '强力赋能',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/强力赋能'),
                path: "华美顾问/强力赋能"
            },
            {
                name: '培训团建',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/培训团建'),
                path: "华美顾问/培训团建"
            },
            // {
            //     name: '赋能资源',
            //     img: '/icons/工具库.svg',
            //     background: 'black',
            //     url: makeUrl('/内容文件/华美/赋能资源'),
            //     path: "华美顾问/赋能资源"
            // },
        ]
    }]
}